import { withFormik } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';
import { Button, Form, Segment } from 'semantic-ui-react';
import styled from 'styled-components';
import { UnitSelect } from './../../../components/form-fields';

const SearchForm = ({ handleReset, handleSubmit, setFieldValue, values }) =>
    <Segment>
        <Form
            onSubmit={handleSubmit}>
            <Form.Group
                widths="equal">
                <Form.Field>
                    <UnitSelect
                        name="unitId"
                        onChange={setFieldValue}
                        value={values["unitId"]} />
                </Form.Field>
            </Form.Group>

            <ButtonsContainer>
                <Button
                    content='Szukaj'
                    icon='search'
                    labelPosition='left'
                    primary
                    type="submit" />
                <Button
                    content='Wyczyść'
                    icon='delete'
                    labelPosition='left'
                    negative
                    onClick={handleReset}
                    type="button" />
            </ButtonsContainer>
        </Form>
    </Segment>

SearchForm.propTypes = {
    onSubmit: PropTypes.func.isRequired
}

const ButtonsContainer = styled.div`
    display: flex;
    justify-content: flex-end;

    & > *:not(:first-child) {
        margin-left: .75rem;
    }
`

const enhance = withFormik({
    handleSubmit: async (values, { props: { onSubmit }, setSubmitting }) => {
        try {
            await onSubmit(values);
        } finally {
            setSubmitting(false);
        }
    },
    mapPropsToValues: () => ({
        'unitId': null
    })
})

export default enhance(SearchForm);


// WEBPACK FOOTER //
// ./src/containers/case-statuses-history/components/SearchForm.js